import React from 'react';
import {Box, FormHelperText, Typography} from "@mui/material";
import {TextFieldComponent} from "../../components/TextFieldComponent";
import {ButtonComponent} from "../../components/ButtonComponent";
import {useForm} from "react-hook-form";
import {LoadingSend} from "../../components/LoadingSendComponent";
import {Mutation} from "@apollo/client/react/components";
import CREATE_PERMISSION from "../../querys/createPermission";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const InsertPermission = ({close, idProduct}) => {
    const {register, handleSubmit, watch} = useForm();
    const user = watch("email", "")

    return (
        <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Adicionando novo membro ao Projeto
            </Typography>
            <Mutation
                mutation={CREATE_PERMISSION}
            >
                {(insertSprint, {data, loading, error}) => {
                    const onSubmit = data => {
                        return insertSprint({
                            variables: {
                                email: data.email,
                                access: true,
                                productId: idProduct
                            }
                        })
                    };
                    if (loading) {
                        return <LoadingSend width={300} heigth={300}/>
                    } else if (error) {
                        return (
                            <>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <TextFieldComponent register={register} name='email' label="usuário"/>
                                    <ButtonComponent type={'submit'} disabled={user == ""}>
                                        Cadastrar</ButtonComponent>
                                </form>
                                <FormHelperText error={true} style={{textAlign: "center"}}>
                                    {error.message}
                                </FormHelperText>
                            </>
                        )
                    } else if (data) {
                        return (
                            <>
                                Cadastrado com sucesso
                                <br/> <br/>
                                <ButtonComponent onClick={close}>Fechar</ButtonComponent>
                            </>
                        )
                    } else {
                        return <form onSubmit={handleSubmit(onSubmit)}>
                            <TextFieldComponent register={register} name='email' label="Usuário"/>
                            <ButtonComponent type={'submit'} disabled={user == ""}>
                                Cadastrar</ButtonComponent>
                        </form>
                    }

                }}
            </Mutation>
        </Box>
    );
};

export {InsertPermission};
